import { render, staticRenderFns } from "./BROCHURE.vue?vue&type=template&id=342aeb45&"
import script from "./BROCHURE.vue?vue&type=script&lang=js&"
export * from "./BROCHURE.vue?vue&type=script&lang=js&"
import style0 from "./BROCHURE.vue?vue&type=style&index=0&id=342aeb45&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports